import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Container, Typography, Box, Alert, Avatar} from '@mui/material';
import {getUserProfile, register} from "../services/api";
import RegisterForm from "../components/RegisterForm";
interface UserProfile {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    image_url: string;
}

const HeaderAvatar: React.FC = () => {
    const navigate = useNavigate();
    const [profile, setProfile] = useState<UserProfile>({
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        image_url: '',
    });
    const [avatarPreview, setAvatarPreview] = useState<string | null>(null);

    useEffect(() => {
        fetchUserProfile();
    }, []);


    const fetchUserProfile = async () => {
        try {
            const data = await getUserProfile();
            setProfile(data);
            setAvatarPreview(data.image_url);
        } catch (error) {
        }
    };

    return (
        <Avatar className='headerAvatar' onClick={()=> navigate('/profile')} src={avatarPreview || profile.image_url} sx={{ width: 36, height: 36, border: 'solid 2px #fff' }}/>
    );
};

export default HeaderAvatar;